import { useState } from 'react';
import hexRgba from 'hex-rgba';
import { color } from '../../../app/theme';

const IconCheck = ({
  onClick,
  className,
  id,
  width,
  height,
  disableHover,
  iconColor,
}) => {
  const [isHover, setIsHover] = useState(false);

  const random = Math.random();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      className={className}
      onMouseEnter={() => {
        if (!disableHover) setIsHover(true);
      }}
      onMouseLeave={() => {
        if (!disableHover) setIsHover(false);
      }}
      onClick={onClick}
    >
      <defs>
        <path
          id="inboxCheck"
          d="M8.73 15.907l-4.233-4.2a.884.884 0 0 0-1.24-.002.86.86 0 0 0-.001 1.225l4.851 4.815c.343.34.898.34 1.241.001L20.743 6.48a.86.86 0 0 0 0-1.225.884.884 0 0 0-1.24 0L8.73 15.907z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M-24-10h268v44H-24z" />
        <g>
          <mask id={`inboxCheckMask${id}${random}`} fill="#fff">
            <use xlinkHref="#inboxCheck" />
          </mask>
          <g
            fill={isHover ? hexRgba(iconColor, 40) : iconColor}
            mask={`url(#inboxCheckMask${id}${random})`}
          >
            <path d="M0 0h24v24H0z" />
          </g>
        </g>
      </g>
    </svg>
  );
};

IconCheck.defaultProps = {
  width: 24,
  height: 24,
  iconColor: color.$11,
};

export default IconCheck;
